import type { Schedule } from '../types/commons';
import { parseTimeDeprecated } from './time';

export const getDurationPerWeekFromSchedules = (schedules: Schedule[] = []) =>
  schedules.reduce(
    (totalMinutes, { starts_at, ends_at }) =>
      totalMinutes + parseTimeDeprecated(ends_at).diff(parseTimeDeprecated(starts_at), 'minutes'),
    0,
  );
